/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Field } from 'react-final-form';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import FormDatePickerField from '../../../components/Form/FormDatePickerField';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

const DateSection = () => {
  const theme = useTheme();

  const questionStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    marginBottom: theme.spacing(1),
  };

  return (
    <>
      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.dateQuestion')}
      </Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Field name="startDate">
            {({ input, meta }) => (
              <FormDatePickerField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.startDate')}
                required
                fullWidth
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field name="expirationDate">
            {({ input, meta }) => (
              <FormDatePickerField
                input={input}
                meta={meta}
                label={LanguageConverterV2('contract.create.expirationDate')}
                fullWidth
              />
            )}
          </Field>
        </Grid>
      </Grid>
    </>
  );
};

export default DateSection;
